"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var enquiryForm = {
    GET_ENQUIRY_FORM_SCHEMA: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetEnquiryFormSchema($token: String!, $state: String) {\n      enquiryForm(token: $token, state: $state) {\n        schema\n        uiSchema\n        formData\n      }\n    }\n  "], ["\n    query GetEnquiryFormSchema($token: String!, $state: String) {\n      enquiryForm(token: $token, state: $state) {\n        schema\n        uiSchema\n        formData\n      }\n    }\n  "]))),
};
exports.default = enquiryForm;
var templateObject_1;
